// A missing value as other code writes it: "null" (JSON, a browser), "None" (Python), "undefined" (JavaScript).
// The one list every reader uses, the backend's apps/common/text.py NO_VALUE_TEXTS (card 941)
const NO_VALUE_TEXTS = new Set(['', 'null', 'none', 'undefined']);

/** A value as written, spaces around it aside, or '' when none was given: blank or a missing value written as text. */
export function writtenText(value: string | null | undefined): string {
  const text = (value ?? '').trim();
  return NO_VALUE_TEXTS.has(text.toLowerCase()) ? '' : text;
}
